import { makeAutoObservable } from 'mobx';

interface IUserSettings {
  showPages: boolean;
}

export default class UserSettingStore {
  userSettings: IUserSettings;

  constructor() {
    makeAutoObservable(this);

    const storedSettings = localStorage.getItem('creatorUserSettings');
    this.userSettings = storedSettings ? JSON.parse(storedSettings) : { showPages: false };
  }

  setSetting = (key: keyof IUserSettings, value: boolean) => {
    this.userSettings[key] = value;
    localStorage.setItem('creatorUserSettings', JSON.stringify(this.userSettings));
  };
}
